import { prepareBanks } from 'shared/mappers/prepareBanks';
import { prepareMortgageBanner } from 'shared/mappers/prepareMortgageBanner';
import { type IBanksPikContractSchema } from 'shared/repositories/special-promos/entities/banks_pik_contract/BanksPikContractSchema';
import { type IDeveloperAwardsForCardSchema } from 'shared/repositories/special-promos/entities/developer_awards_for_card/DeveloperAwardsForCardSchema';
import { type IDeveloperFactWebSchema } from 'shared/repositories/special-promos/entities/developer_fact_web/DeveloperFactWebSchema';
import { type IDeveloperRatingsForCardSchema } from 'shared/repositories/special-promos/entities/developer_ratings_for_card/DeveloperRatingsForCardSchema';
import { type IMortgageCalculatorSchema } from 'shared/repositories/special-promos/entities/get_cached_content/MortgageCalculatorSchema';
import { type INewbuildingsPlusBlocksPikContractSchema } from 'shared/repositories/special-promos/entities/newbuildings_plus_blocks_pik_contract/NewbuildingsPlusBlocksPikContractSchema';
import {
  type TGetCachedContentResponse,
  fetchGetCachedContent,
} from 'shared/repositories/special-promos/v1/get-cached-content';
import { type IApplicationContext } from 'shared/types/applicationContext';
import { type IMortgageBanner } from 'shared/types/mortgageBanner';
import { ResponseError } from 'shared/utils/errors';

export async function getSpecialProjectsBlocks(
  { logger, httpApi }: IApplicationContext,
  regionId?: number,
): Promise<{
  banksPik: IBanksPikContractSchema[];
  developerAwards: IDeveloperAwardsForCardSchema | null;
  developerRatings: IDeveloperRatingsForCardSchema | null;
  facts: IDeveloperFactWebSchema[];
  mortgageBannerPik: IMortgageBanner | null;
  mortgageCalculatorPik: IMortgageCalculatorSchema | null;
  newbuildingsPlusBlocksPik: INewbuildingsPlusBlocksPikContractSchema[];
  phone: string;
}> {
  try {
    const { response, statusCode } = await fetchGetCachedContent<TGetCachedContentResponse, TGetCachedContentResponse>({
      httpApi,
      parameters: {
        blocks:
          'banksPik,newbuildingsPlusBlocksPik,phonesPik,mortgageBannerPik,mortgageCalculatorPik,developerAwards,developerRatings',
        regionId,
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSpecialProjectsBlocks',
        message: 'Не удалось получить контент для блоков специальных проектов',
      });
    }

    return {
      banksPik: response.banksPik ? prepareBanks(response.banksPik) : [],
      developerAwards: response.developerAwards ?? null,
      developerRatings: response.developerRatings ?? null,
      facts: response.facts ?? [],
      mortgageBannerPik: response.mortgageBannerPik ? prepareMortgageBanner(response.mortgageBannerPik) : null,
      mortgageCalculatorPik: response.mortgageCalculatorPik ?? null,
      newbuildingsPlusBlocksPik: response.newbuildingsPlusBlocksPik ?? [],
      phone: response.phonesPik?.phone ? `+${response.phonesPik?.phone}` : '',
    };
  } catch (ex) {
    logger.warning(ex as Error, { message: 'Получение актуальной версии блоков спецпроектов завершилось ошибкой' });

    return {
      banksPik: [],
      developerAwards: null,
      developerRatings: null,
      facts: [],
      mortgageBannerPik: null,
      mortgageCalculatorPik: null,
      newbuildingsPlusBlocksPik: [],
      phone: '',
    };
  }
}
